import { useState } from "react";
import { Card, Col, Row, Typography, Button, Checkbox, Popconfirm } from "antd";
import { DeleteOutlined, PhoneOutlined, MailOutlined, EditOutlined } from "@ant-design/icons";
import { CompanyContact } from "@bindeleddet/core/types";
import { useViewport } from "@bindeleddet/core/hooks";
import CreateOrEditContact from "./CreateOrEditContact";

interface Props {
  contact: CompanyContact;
  mainLoading: boolean;
  handleMain: (contact: CompanyContact) => void;
  handleDelete: (contact: CompanyContact) => void;
  handleUpdate: (contact: CompanyContact) => void;
}

const CompanyContactBox: React.FC<Props> = ({ contact, mainLoading, handleMain, handleDelete, handleUpdate }) => {
  const [showEditContactModal, setShowEditContactModal] = useState<boolean>(false);
  const { Text } = Typography;

  const { width } = useViewport();
  const breakpoint = 768;

  return (
    <Card style={{ margin: ".8em 0" }}>
      <Row gutter={[10, 15]} style={{ height: "100%" }}>
        <Col md={8} sm={24} xs={24}>
          <Row>
            <Text strong>{`${contact.first_name} ${contact.last_name}`}</Text>
          </Row>
          <Row>
            <Text italic>{!contact.position || contact.position === "" ? "Stilling ukjent" : contact.position}</Text>
          </Row>
        </Col>
        <Col md={10} sm={24} xs={24}>
          <Row>
            <PhoneOutlined style={{ fontSize: "12px", position: "relative", padding: "5px 5px 0 0" }} />
            <Text>{contact.telephone !== "" ? contact.telephone : "Nummer ukjent"}</Text>
          </Row>
          <Row>
            <MailOutlined style={{ fontSize: "12px", position: "relative", padding: "5px 5px 0 0" }} />
            <Text>{contact.email !== "" ? contact.email : "Mail ukjent"}</Text>
          </Row>
        </Col>
        <Col md={3} sm={24} xs={24}>
          <Row>
            <Text>Hoved:</Text>
          </Row>
          <Row>
            <Checkbox
              style={{ transform: "scale(1.3)", pointerEvents: mainLoading ? "none" : "auto" }}
              checked={contact.main_contact}
              disabled={mainLoading}
              onChange={() => handleMain(contact)}
            />
          </Row>
        </Col>
        <Col md={3} sm={24} xs={24} style={{ textAlign: width < breakpoint ? "left" : "right" }}>
          <CreateOrEditContact
            isOpen={showEditContactModal}
            onClose={() => setShowEditContactModal(false)}
            contact={contact}
            handleUpdate={updatedContact => handleUpdate(updatedContact)}
          />
          <Button type="primary" onClick={() => setShowEditContactModal(true)}>
            <EditOutlined />
          </Button>
          <Popconfirm
            title={`Slett ${contact.first_name} ${contact.last_name}`}
            okText="Slett"
            okType="danger"
            cancelText="Avbryt"
            onConfirm={() => handleDelete(contact)}
          >
            <Button danger type="primary" style={{ marginLeft: "5px", marginTop: "5px" }}>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </Col>
      </Row>
    </Card>
  );
};

export default CompanyContactBox;
